
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/profile-menu/js/profile-menu';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/manage-alerts/js/manage-alerts';
   //I've found a weird interaction between manage-alerts and this one, 'select all' is shared between, interaction must be moved to basic/inputs
const main = (UX) => {
    const $dropblockUl = Array.prototype.slice.call(document.querySelectorAll('.profile-menu, body')),
        $alerts = Array.prototype.slice.call(document.querySelectorAll('.alerts, #institutionUsageReport, body'))

try {
        if ($dropblockUl.length ) {
            UX.dropblockUl.init($dropblockUl);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alerts.length ) {
            UX.alerts.init($alerts);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        